module.exports = __webpack_public_path__ + "static/media/arrowLeft.923b7cd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/client/validation/arrowLeft.svg
// module id = 245
// module chunks = 16